<template>
  <div>
    <v-select 
        :value="selected_connection_type"
        v-bind:items="collections"
        item-value="code" 
        item-text="description" 
        :label="label"
        :dense="isDense"
        :clearable="false"
        @change="updateData">
    </v-select>
  </div>
</template>

<script>
  export default {
    watch:{
        selected_connection_type: {            
            handler(){
                // this is needed when the selected language is set from outside this component
                // the change-event will not fire so we watch the value and emit the change if needed
                this.updateData(this.selected_connection_type);
            } 
        },
    },       
    props: {
      selected_connection_type: {
          type: String,
          default: ''
      },            
      label: {
        type: String,
        default: ''
      },  
      field: {
          type: String,
          default: 'hgrp_conn_type',
      },
      isDense:{
          type: Boolean,
          default: true
      }
    },  
    data() {
      return {
        collections:[]
      }
    },      
    created () {
      this.collections = 
      [
        {code: 'Park', description: 'Park'},
        {code: 'Collection', description: 'Collection'}
      ];
    },
    mounted () {
      this.updateData(this.selected_connection_type);
    },
    methods: {
      updateData(v){
          this.$emit('updateData', { "field": this.field, "value": v === null ? 'Park' : v })
      }           
    }   
  }
</script>

<style scoped>

</style>